"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isHTML = exports.isUndefined = exports.toTitleCase = exports.transformAddressesForOptions = exports.craftyClicksUrl = exports.promiseWithTimeout = exports.requestWithPromise = exports.downLoadFile = exports.getSortableColumnSortClass = void 0;

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

var getSortableColumnSortClass = function getSortableColumnSortClass(orderBy, orderAsc, property) {
  if (orderBy !== property) {
    return "";
  }

  if (orderAsc) {
    return "sort-asc";
  }

  return "sort-desc";
};

exports.getSortableColumnSortClass = getSortableColumnSortClass;

var downLoadFile = function downLoadFile(name, base64Encoding, fileExtension) {
  var src = "data:application/binary;base64,".concat(base64Encoding);

  if (window.navigator && window.navigator.msSaveOrOpenBlob) {
    var byteCharacters = atob(base64Encoding);
    var byteNumbers = new Array(byteCharacters.length);

    for (var i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i);
    }

    var byteArray = new Uint8Array(byteNumbers);
    var blob = new Blob([byteArray], {
      type: "application/binary"
    });
    var fileName = name;
    window.navigator.msSaveOrOpenBlob(blob, fileName);
  } else {
    var downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);
    var _fileName = name;
    downloadLink.href = src;
    downloadLink.download = _fileName;
    downloadLink.click();
    document.body.removeChild(downloadLink);
  }
};

exports.downLoadFile = downLoadFile;

var requestWithPromise =
/*#__PURE__*/
function () {
  var _ref = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee2(url, headers) {
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            return _context2.abrupt("return", new Promise(
            /*#__PURE__*/
            function () {
              var _ref2 = _asyncToGenerator(
              /*#__PURE__*/
              regeneratorRuntime.mark(function _callee(resolve, reject) {
                var result;
                return regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return fetch(url, {
                          method: 'GET',
                          headers: headers ? _objectSpread({}, headers) : {}
                        });

                      case 2:
                        result = _context.sent;
                        resolve(result);

                      case 4:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));

              return function (_x3, _x4) {
                return _ref2.apply(this, arguments);
              };
            }()));

          case 1:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));

  return function requestWithPromise(_x, _x2) {
    return _ref.apply(this, arguments);
  };
}();

exports.requestWithPromise = requestWithPromise;

var promiseWithTimeout =
/*#__PURE__*/
function () {
  var _ref3 = _asyncToGenerator(
  /*#__PURE__*/
  regeneratorRuntime.mark(function _callee3(httpReq, milliseconds) {
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            return _context3.abrupt("return", new Promise(function (resolve, reject) {
              setTimeout(function () {
                reject(new Error('Data fetch failed in ' + milliseconds + ' ms'));
              }, milliseconds);
              httpReq.then(function (result) {
                resolve(result);
              }, function (err) {
                reject(err);
              });
            }));

          case 1:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));

  return function promiseWithTimeout(_x5, _x6) {
    return _ref3.apply(this, arguments);
  };
}();

exports.promiseWithTimeout = promiseWithTimeout;

var craftyClicksUrl = function craftyClicksUrl(url, value) {
  if (url) {
    return url;
  }

  return "https://sit-apis.arag.co.uk/addresslookup/api/PostcodeLookup?postcode=".concat(value);
};

exports.craftyClicksUrl = craftyClicksUrl;

var transformAddressesForOptions = function transformAddressesForOptions(data) {
  var addresses = [];

  if (data) {
    addresses = data.map(function (x) {
      var label = toTitleCase(x.addressline1);
      if (x.addressline2 != null && !isUndefined(x.addressline2) && x.addressline2.length > 0) label += ", ".concat(toTitleCase(x.addressline2));
      if (x.addressline3 != null && !isUndefined(x.addressline3) && x.addressline3.length > 0) label += ", ".concat(toTitleCase(x.addressline3));
      return {
        label: label,
        value: {
          addressline1: x.addressline1 ? toTitleCase(x.addressline1) : null,
          addressline2: x.addressline2 ? toTitleCase(x.addressline2) : null,
          addressline3: x.addressline3 ? toTitleCase(x.addressline3) : null
        },
        postcode: x.postcode ? x.postcode : null,
        county: x.county ? toTitleCase(x.county) : null,
        town: x.town ? toTitleCase(x.town) : null,
        province: x.province ? toTitleCase(x.province) : null
      };
    });
    addresses = addresses.map(function (item, index) {
      return {
        value: index,
        label: item.label,
        lines: item.value,
        postcode: item.postcode,
        county: item.county,
        town: item.town,
        province: item.province
      };
    });
  } else {
    addresses = [];
  }

  return addresses;
};

exports.transformAddressesForOptions = transformAddressesForOptions;

var toTitleCase = function toTitleCase(string) {
  string = string.toLowerCase().split(' ');

  for (var i = 0; i < string.length; i++) {
    string[i] = string[i].charAt(0).toUpperCase() + string[i].slice(1);
  }

  return string.join(' ');
};

exports.toTitleCase = toTitleCase;

var isUndefined = function isUndefined(v) {
  return typeof v === 'undefined';
};

exports.isUndefined = isUndefined;

var isHTML = function isHTML(str) {
  var a = document.createElement('div');
  a.innerHTML = str;

  for (var c = a.childNodes, i = c.length; i--;) {
    if (c[i].nodeType === 1) return true;
  }

  return false;
};

exports.isHTML = isHTML;